module.exports = __webpack_public_path__ + "953f0fed433565f27e6b7b2aa97e4610.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/_common/BeerCard/images/summer-seasonal.png
// module id = g79e
// module chunks = 0